import _includes from "lodash/includes"

export const optionsReasonSelectDefault = [
  {
    label: "Interrompido",
    value: "Interrompido"
  },
  {
    label: "Intermitência",
    value: "Intermitência"
  },
  {
    label: "Falha navegação",
    value: "Falha navegação"
  },
  {
    label: "Performance",
    value: "Performance"
  },
  {
    label: "Eco / Picotes / Ruídos / Volume",
    value: "Eco / Picotes / Ruídos / Volume"
  },
  {
    label: "Ligação muda",
    value: "Ligação muda"
  },
  {
    label: "Não completamento de chamadas",
    value: "Não completamento de chamadas"
  },
  {
    label: "Não recebimento de chamadas",
    value: "Não recebimento de chamadas"
  },
  {
    label: "Queda de ligações",
    value: "Queda de ligações"
  },
  {
    label: "Tom de ocupado",
    value: "Tom de ocupado"
  }
]

export const optionsReasonSelectRFO = [
  {
    label: "Interrompido",
    value: "Interrompido"
  },
  {
    label: "Intermitência",
    value: "Intermitência"
  },
  {
    label: "Navegação",
    value: "Navegação"
  },
  {
    label: "Eco / Picotes / Ruídos / Volume",
    value: "Eco / Picotes / Ruídos / Volume"
  },
  {
    label: "Ligação Muda",
    value: "Ligação Muda"
  },
  {
    label: "Não Completamento de Chamadas",
    value: "Não Completamento de Chamadas"
  },
  {
    label: "Não Recebimento de Chamadas",
    value: "Não Recebimento de Chamadas"
  },
  {
    label: "Queda de Ligações",
    value: "Queda de Ligações"
  },
  {
    label: "Tom de Ocupado",
    value: "Tom de Ocupado"
  }
]

export const optionsReasonProgramming = [
  {
    label: "Alteração de Roteamento na VPN",
    value: "Alteração de Roteamento na VPN"
  },
  {
    label: "Bloqueio de aplicações ou sites (URL)",
    value: "Bloqueio de aplicações ou sites (URL)"
  },
  {
    label: "Configuraçção ou alteração de autenticação",
    value: "Configuraçção ou alteração de autenticação"
  },
  {
    label: "Configuração de Community SNMP (CPE)",
    value: "Configuração de Community SNMP (CPE)"
  },
  {
    label: "Configuração de DHCP (CPE)",
    value: "Configuração de DHCP (CPE)"
  },
  {
    label: "Configuraçãi de firewall",
    value: "Configuraçãi de firewall"
  },
  {
    label: "Configuração de voz para link terceiros",
    value: "Configuração de voz para link terceiros"
  },
  {
    label: "Configuração IPSec",
    value: "Configuração IPSec"
  },
  {
    label: "Configuração SDWAN",
    value: "Configuração SDWAN"
  },
  {
    label: "Criação ou alteração de SSID",
    value: "Criação ou alteração de SSID"
  },
  {
    label: "DNS Reverso",
    value: "DNS Reverso"
  },
  {
    label: "Facilidades de Voz Total",
    value: "Facilidades de Voz Total"
  },
  {
    label: "Inclusão de rota na VPN MPLS",
    value: "Inclusão de rota na VPN MPLS"
  },
  {
    label: "Liberação de porta física no CPE (CPE)",
    value: "Liberação de porta física no CPE (CPE)"
  },
  {
    label: "Liberação de trânsito para o BGP",
    value: "Liberação de trânsito para o BGP"
  },
  {
    label: "Liberar IP e protocolo na ACL Anti fraude (CPE)",
    value: "Liberar IP e protocolo na ACL Anti fraude (CPE)"
  },
  {
    label: "QoS",
    value: "QoS"
  },
  {
    label: "Validação de funcionamento de serviço com o cliente",
    value: "Validação de funcionamento de serviço com o cliente"
  },
  {
    label: "Configuração Cloud Phone Pro",
    value: "Configuração Cloud Phone Pro"
  },
  {
    label: "Configuração Cloud Phone Pro DDI",
    value: "Configuração Cloud Phone Pro DDI"
  },
  {
    label: "Desprogramação Nro Virtual Móvel - Voz Total",
    value: "Desprogramação Nro Virtual Móvel - Voz Total"
  },
  {
    label: "Desprogramação IPCel - Voz Total",
    value: "Desprogramação IPCel - Voz Total"
  },
  {
    label: "Outros",
    value: "Outros"
  }
]

export const userType = "portal_b2b"

export const optionsRequestType = [
  {
    id: "incident",
    label: "Incidente",
    checked: true,
    value: "INCIDENTE"
  },
  {
    id: "RFO",
    label: "RFO",
    checked: false,
    value: "RFO"
  },
  {
    id: "programming",
    label: "Programação",
    checked: false,
    value: "PROGRAMACAO SERVICO"
  }
]

export const optionsOfficeHoursSelect = [
  {
    label: "08h às 18h",
    value: "08h às 18h"
  },
  {
    label: "24 Horas",
    value: "24 Horas"
  },
  {
    label: "Agendado",
    value: "Agendado"
  }
]

export const optionsAccessAuthorizedSelect = [
  {
    label: "SIM",
    value: "1"
  },
  {
    label: "NÃO",
    value: "0"
  }
]

export const PRODUCT_WITHOUT_BLOCKING = "PRODUTO SEM BLOQUEIO"
export const NOT_MASSIVE = "NAO"
export const CLOSED_STATUS = "FECHADO"
export const OPEN_STATUS = "ABERTO"

export const SUPPORT_STEPS = {
  SUPPORT_CELLPHONE: "support-cellphone",
  SUPPORT_OPTIONS: "support-options",
  TEST_REQUIRED: "test-required",
  SAT_TEST: "sat-test",
  SAT_TEST_RESULT: "sat-test-result",
  SAT_TEST_COMPLETED: "sat-test-completed",
  SUPPORT_OTHERS: "support-others",
  SELECT_PRODUCT: "select-product",
  INCIDENT_FORM_TEST: "form-test",
  SUPPORT_INTERNET: '"support-internet"',
  SUPPORT_FIXO: "support-fixo",
  SUPPORT_SD_WAN: "support-sd-wan"
}

export const TEST_RESULTS = {
  SUCCESS: "success",
  TECHNICAL_ANALYSIS: "analysis",
  IPV6: "ipv6",
  TECHNICAL_VISIT: "visit",
  BROADBAND_LIMIT: "broadband",
  NEXT_STEP: "next",
  CORRECTION: "correction"
}

export const statusCodeForSuccess = [
  "0",
  "10",
  "B10",
  "A226",
  "B226",
  "A10",
  "235300",
  "226300",
  "226",
  "111",
  "443",
  "332",
  "3321317",
  "13051317",
  "1305",
  "1309",
  "1310",
  "1312",
  "1313",
  "1315",
  "1317",
  "1318"
]

export const statusCodesForN2 = [
  "100",
  "102",
  "105",
  "107",
  "111200",
  "113301",
  "001",
  "002",
  "004",
  "103",
  "106",
  "108",
  "138",
  "143",
  "153",
  "157",
  "158",
  "159",
  "214",
  "217",
  "219",
  "220",
  "221",
  "224",
  "226",
  "229",
  "231",
  "232",
  "234",
  "235",
  "238",
  "239",
  "240",
  "241",
  "243",
  "253",
  "258",
  "259",
  "260",
  "261",
  "262",
  "263",
  "266",
  "267",
  "268",
  "270",
  "272",
  "277",
  "278",
  "281",
  "286",
  "289",
  "290",
  "336",
  "342",
  "332",
  "1304",
  "1306",
  "1307",
  "1320",
  "113318",
  "1303301",
  "1303304",
  "1303315",
  "1303318"
]

export const statusCodesForIPV6 = ["132", "135", "154"]

export const statusCodesForOpenCode = [
  "307",
  "318",
  "320",
  "204",
  "7204",
  "7307",
  "A204",
  "B204",
  "111236",
  "111203",
  "111222",
  "111237",
  "111301",
  "332236",
  "332203",
  "332222",
  "1305236",
  "1305203",
  "1305222",
  "1112030",
  "1112220",
  "A2030",
  "A2220",
  "B2030",
  "B2220"
]

export const statusCodeForFcrLead = ["172", "173", "7172", "7173", "324", "163"]

export const STATUS_MAPPING = [
  {
    condition: (idStatus) => _includes(statusCodeForSuccess, idStatus),
    result: TEST_RESULTS.SUCCESS
  },
  {
    condition: (idStatus) => _includes(statusCodesForN2, idStatus),
    result: TEST_RESULTS.TECHNICAL_ANALYSIS
  },
  {
    condition: (idStatus) => _includes(statusCodesForIPV6, idStatus),
    result: TEST_RESULTS.IPV6
  },
  {
    condition: (idStatus) => _includes(statusCodesForOpenCode, idStatus),
    result: TEST_RESULTS.TECHNICAL_VISIT
  },
  {
    condition: (idStatus) => _includes(statusCodeForFcrLead, idStatus),
    result: TEST_RESULTS.BROADBAND_LIMIT
  }
]



// WEBPACK FOOTER //
// ./src/scenes/AddTicket/constants.js